<template>
  <div v-if="!scanned" class="scanner-page">
    <Header
      :HeaderTitle="this.$store.getters.getScanInfo.scanning + ' scan'"
      :HeaderSubTitle="subtitle"
      :ShowBack="true"
      v-on:back="back"
    ></Header>

    <div class="scan-wrap">
      <div class="scan-content">
        <QrcodeStream @error="onError" @detect="onDetect" :constraints="{ facingMode }"></QrcodeStream>
        <div class="scan-overlay" aria-hidden="true">
          <em></em>
        </div>
        <p v-if="error" class="scanner-error" role="alert">{{ error }}</p>
      </div>
      <div class="scan-btn-wrap">
        <button type="button" class="btn btn--default btn-camera-switch" @click="changeCameraView" aria-label="Switch camera">
          <img src="../assets/images/scan/icon-camera-switch.svg" alt="" aria-hidden="true" />
        </button>
        <button type="button" @click="back" class="btn btn--secondary scan-cancel">Cancel</button>
      </div>
    </div>
  </div>
  <ScannedResult
    v-if="scanned"
    :QrValue="decodedStream"
  ></ScannedResult>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import ScannedResult from "../components/ScannedResultComponent.vue";
import Header from "../components/HeaderComponent.vue";

export default {
  components: { QrcodeStream, ScannedResult, Header },
  name: "ScannerView",
  data: () => ({
    facingMode: "environment",
    decodedStream: "",
    error: "",
  }),
  methods: {
    back() {
      this.$store.commit("setScanned", {
        isScanned: false,
      });

      this.$router.back();
    },
    changeCameraView(){
      this.facingMode = this.facingMode == "environment" ? "user" : "environment";
    },
    onDetect(result) {
      if (this.scanned) return;
      this.error = "";

      if(result.length > 0){
        this.decodedStream = result[0].rawValue;
        this.$store.commit("setScanned", { isScanned: true });
      }
      else{
        this.error = "ERROR: Scanning error, please try again";
      }
    },
    onError(error) {
      if (error.name === "NotAllowedError") {
        this.error = "ERROR: you need to grant camera access permission";
      } 
      else if (error.name === "NotFoundError") {
        this.error = "ERROR: no camera on this device";
      }
      else if (error.name === "NotSupportedError") {
        this.error = "ERROR: secure context required (HTTPS, localhost)";
      }
      else if (error.name === "NotReadableError") {
        this.error = "ERROR: is the camera already in use?";
      }
      else if (error.name === "OverconstrainedError") {
        this.error = "ERROR: installed cameras are not suitable";
      }
      else if (error.name === "StreamApiNotSupportedError") {
        this.error = "ERROR: Stream API is not supported in this browser";
      }
      else if (error.name === "InsecureContextError") {
        this.error = "ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.";
      }
      else {
        this.error = `ERROR: Camera error (${error.name})`;
      }
    }
  },
  computed: {
    scanned() {
      return this.$store.getters.getScanned;
    },
    subtitle() {
      return this.$store.getters.getScanInfo.scanning === "Session"
        ? this.$store.getters.getProgramName
        : this.$store.getters.getEventName;
    },
  },
  created() {
    this.$store.commit("setScanned", {
      isScanned: false,
    });
  },
};
</script>
